import React, {  Component } from 'react';
import { connect } from 'react-redux';
import { Link, browserHistory } from 'react-router';

import {
	getMessages,
	deleteMessage,saveEditPriceExports
} from '../../../../redux/actions';

class PriceExportMessage extends Component {

	constructor(props) {
        super(props);
        this.state = {
			message:[],
			confirmationMessage:'',
			deletingMessageData:''
        }
    }

	componentWillMount() {
		const self = this;
		self.props.getMessages(`isSiteManagment=true`, true, response => {
				self.setState({
						message: JSON.parse(JSON.stringify(response.responseObject))
					});
			});
	}

	handleCreateMessage(event) {
		event.preventDefault();
		browserHistory.push('/siteManagement/priceExportMessage/create');
	}
	handleEditMessage(item, event) {
		event.preventDefault();
		const self = this;
		self.props.saveEditPriceExports(item);
		browserHistory.push('/siteManagement/priceExportMessage/edit');
	}

	handleDeletePriceExports(item, index, event) {
        event.preventDefault();
        const self = this;
        self.setState({
            confirmationMessage: '',
            deletingMessageData: item
        }, () => {
            self.props.deleteMessage(item, `message_id=${item.message_id}`, response => {
                if (response.status) {
                    // Remove deleted message from the state
                    const updatedMessages = self.state.message.filter((message, msgIndex) => msgIndex !== index);
                    self.setState({
                        message: updatedMessages,
                        confirmationMessage: 'Message has been successfully deleted.'
                    });
                } else {
                    browserHistory.push('/error');
                }
            });
        });
    }
    render() {
		const self = this;
        return (
            <div>
				<div className="push">
					<h1 className="pageTitle">PRICE EXPORT MESSAGE</h1>
				</div>
				{this.state.confirmationMessage && <p className="bold red">{this.state.confirmationMessage}</p>}
				{<table className="dataTable savedBrochuresTable savedBrochuresASMTable">
				          	<thead>
					            <tr>
									<th>Message</th>
									<th>Start Date</th>
									<th>End Date</th>
									<th>Edit Msg</th>
									<th>Delete Msg</th>
					            </tr>
				          	</thead>
							<tbody>
								{self.state.message && self.state.message.length >0 && self.state.message.map((item, index) => {
									return <tr key={index}>
												<td>{item.message_description}</td>
												<td>{item.start_date}</td>
												<td>{item.end_date}</td>
												{<td>
													<a className="editTemplateIcon" href="" onClick={this.handleEditMessage.bind(this, item)}>
														<img src="../images/icon-edit-brochure-large.png" width={26} height={21} alt="Edit Template" title="Edit Template" />
													</a>
												</td>}
											<td><a className="xMe" href="" 
											onClick={this.handleDeletePriceExports.bind(this, item, index)}
											>X</a></td>
										</tr>
								})}
				          	</tbody>
				        </table>
					} 
                    <p className="textRight">
						<input type="button" onClick={this.handleCreateMessage.bind(this)} className="blueButton uppercase" defaultValue="Create Message" />
					</p>
                    <p>
						<Link to="/siteManagement">Back to Site Management</Link>
					</p>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
	return {state};
};

const mapDispatchToProps = (dispatch) => ({
	getMessages: (queryString, showLoader, callback) => dispatch(getMessages(queryString, showLoader, callback)),
	deleteMessage: (payload, queryStringParams, callback) => dispatch(deleteMessage(payload, queryStringParams, callback)),
	saveEditPriceExports: (data) => dispatch(saveEditPriceExports(data)),
});

PriceExportMessage = connect(mapStateToProps, mapDispatchToProps)(PriceExportMessage);
export default PriceExportMessage;


// WEBPACK FOOTER //
// ./src/App/components/PostLogin/SiteManagement/PriceExportMessage/index.js